<template>
<div>
    <div v-show="!mostrarEventos">
        <b-card no-body>
            <b-card-header>
                <span class="h5">
                    Plano de Trabalho
                </span>
            </b-card-header>
            <b-card-body>
                <div>
                    <app-erros-box
                        :erros="erros"
                        v-if="erros.length > 0"
                    ></app-erros-box>
                    <app-tabela
                        idTabela="tbAcoesPlanoTrabalho"
                        :itens="acoesPlanoTrabalho"
                        :campos="campos"
                        :itensPorPagina="itensPorPagina"
                        :bordered="false"
                        :small="false">
                    <template slot="botoes">
                        <b-button-group class="float-right">
                            <btn-inserir-acao-plano-trabalho
                                :convenio="convenio"
                                class="mr-2"
                                v-if="$temAcessoView('CONV-PLANO-01')"
                                @atualizarLista="atualizarLista()">
                            </btn-inserir-acao-plano-trabalho>
                        </b-button-group>
                    </template>
                    <template slot="acoes" slot-scope="data">
                            <btn-atualizar-acao
                                v-if="$temAcessoView('CONV-PLANO-01') && data.codSituacao != 1"
                                :convenio="convenio"
                                :acao="data"
                                @atualizarLista="atualizarLista()">
                            </btn-atualizar-acao>
                            <btn-cancelar-acao
                                v-if="$temAcessoView('CONV-PLANO-02') && data.codSituacao != 1"
                                class="text-danger float-left mr-1"
                                :convenio="convenio"
                                :acao="data"
                                @atualizarLista="atualizarLista()"
                            ></btn-cancelar-acao>
                            <btn-mostrar-eventos
                                v-if="$temAcessoView('CONV-PLANO-02')"
                                @atualizarEvento="eventos = $event"
                                @atualizarConsultoria="consultorias = $event"
                                @receberAcao="acao = $event"
                                :acao="data"
                            ></btn-mostrar-eventos>
                    </template>
                    <template slot="nomeAcao" slot-scope="data">
                            <p class="text-left m-0">
                                {{ data.nomeAcao }}
                            </p>
                        </template>
                        <template slot="nomeGestor" slot-scope="data">
                            <p class="text-left m-0">
                                {{ data.nomeGestor }}
                            </p>
                        </template>
                        <template slot="nomeUnidade" slot-scope="data">
                            <p class="text-left m-0">
                                {{ data.nomeUnidade }}
                            </p>
                        </template>
                        <template slot="situacao" slot-scope="data">
                            <app-status
                                :status="data.situacao.toUpperCase()"
                            ></app-status>
                        </template>
                    </app-tabela>
                </div>
            </b-card-body>
        </b-card>
    </div>
    <div v-if="mostrarEventos">
        <eventos
            :convenio="convenio"
            :acao="acao"
            :eventos="eventos"
            :consultorias="consultorias"
            @atualizarAcao="atualizarLista()"
            @voltarAcao="voltarAcao()">
        </eventos>
    </div>
</div>
</template>

<script>
    import ConveniosServicos from '../ConveniosServicos'
    import BtnInserirAcaoPlanoTrabalho from '../cadastro/acaoPlanoTrabalho/BtnInserirAcaoPlanoTrabalho'
    import BtnCancelarAcao from '../cadastro/acaoPlanoTrabalho/BtnCancelarAcao'
    import BtnAtualizarAcao from '../cadastro/acaoPlanoTrabalho/BtnAtualizarAcao.vue'
    import BtnMostrarEventos from '../cadastro/acaoPlanoTrabalho/BtnMostrarEventos.vue'
    import Eventos from '../cadastro/acaoPlanoTrabalho/eventos/Eventos.vue'

    export default {
        components: {
            BtnInserirAcaoPlanoTrabalho,
            BtnCancelarAcao,
            BtnAtualizarAcao,
            BtnMostrarEventos,
            Eventos
        },

        props: {
            convenio: {
                type: Object,
                default: () => ({})
            }
        },

        data() {
            return {
                erros: [],
                eventos: null,
                consultorias:null,
                acao:null,
                itensPorPagina: 5,
                acoesPlanoTrabalho: [],
                campos: [
                    {
                        key: 'nomeAcao',
                        label: 'Nome da Ação',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'nomeGestor',
                        label: 'Gestor de Execução',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'nomeUnidade',
                        label: 'Unidade',
                        filterable: true,
                        sortable: true
                    },
                    {
                    key: 'situacao',
                    label: 'Situação',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                    },
                    {
                        key: 'acoes',
                        label: ''
                    }
                ],

            }
        },

        methods:{
            atualizarLista(){
                this.$store.dispatch('addRequest')
                ConveniosServicos.obterPorId(this.convenio.idConvenio)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.acoesPlanoTrabalho = response.data.acoesPlanoTrabalho
                        }
                        else{
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            },
            atualizarEvento(eventos) {
                this.eventos = eventos
            },
            atualizarConsultoria(consultorias) {
                this.consultorias = consultorias
            },
            receberAcao(acao) {
                this.acao = acao
            },
            voltarAcao(){
                this.eventos = null;
                this.consultorias = null;
            }
        },
        computed: {
            mostrarEventos() {
                return this.eventos != null
            },
            mostrarConsultorias() {
                return this.consultorias != null
            }
        },
        watch:{
            convenio(){
                if(this.convenio){
                    this.acoesPlanoTrabalho = this.convenio.acoesPlanoTrabalho
                }
            }
        },
}
</script>
